import api from "src/shared/api";
import { EQueryTagTypes, ISwoolBaseResponse } from "src/shared/types/api";
import { IPartnerDto } from "src/shared/types/partner.types";

const partnersApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPartner: build.query<IPartnerDto, string>({
      query: (id) => {
        return {
          url: `/api/partners/${id}`,
          method: "GET",
        };
      },
      transformResponse: (data: ISwoolBaseResponse<IPartnerDto>) => {
        return data.data;
      },
      providesTags: (response) => {
        const tags = [
          { type: EQueryTagTypes.PARTNERS, id: response?.id },
          { type: EQueryTagTypes.PARTNERS, id: "LIST" },
        ];
        if (response?.bank_account) {
          tags.push({
            type: EQueryTagTypes.PARTNER_BANK_ACCOUNTS,
            id: response?.bank_account?.id,
          });
        }

        if (response?.license) {
          tags.push({
            type: EQueryTagTypes.PARTNER_LICENSES,
            id: response?.license?.id,
          });
        }

        return tags;
      },
    }),
    getHistoryCategories: build.query({
      query: () => {
        return {
          url: `/api/history/categories`,
          method: "GET",
        };
      },
    }),
    resetClientPersonMfa: build.mutation({
      query: ({ partner, partnerContactPerson }) => ({
        url: `/api/partners/${partner}/contact_person/${partnerContactPerson}/reset-pcp-mfa`,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useGetPartnerQuery,
  useLazyGetHistoryCategoriesQuery,
  useResetClientPersonMfaMutation,
} = partnersApi;
